/* eslint-disable new-cap */
/* eslint-disable no-undef */
// import mockData from './mockData'
import axios from 'axios'
import {baseUrl} from '../index'
// const useMocks = false
//
// const mockPost = function (response, isError = false) {
//     return new Promise((resolve, reject) => {
//         setTimeout(() => {
//             const action = !isError ? resolve : reject
//             action(response)
//         }, 3000)
//     })
// }

const TIMEOUT = 60000

const Request = function (config = {withAuth: false, opts: {}}) {
    const options = {
        ...config.opts,
        headers: config.withAuth && {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            ...(config.opts) && config.opts.headers
        }
    }
    return {
        get () {
            return {
                method: 'GET',
                ...options
            }
        },

        post (body) {
            return {
                method: 'POST',
                ...options,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    ...options.headers
                },
                data: body
            }
        },

        delete () {
            return {
                method: 'DELETE',
                ...options
            }
        }
    }
}

// Add a request interceptor

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    console.log(error)
    if (error && error.response && error.response.status === 401) {
        localStorage.clear()
        window.location = baseUrl
    }
    return Promise.reject(error);
});
export const makeRequest = function ({url, method, config}, {request, success, error}, body = {}, onSuccess) {
    return dispatch => {
        dispatch(request)
        const options = Request(config)[method](body)
        Promise.race([
            axios({...options, url}),
            new Promise((resolve, reject) =>
                setTimeout(() => reject(null), TIMEOUT))
        ]).then(json => {
            dispatch(success(json.data))
            if (onSuccess) onSuccess()
        })
            .catch(err => {
                dispatch(error(err))
            })
    }
}

export const fetchWithTimeout = async function ({url, method, config}, body = {}, timeout = TIMEOUT) {
    const options = Request(config)[method](body)
    return Promise.race([
        axios({ ...options, url }),
        new Promise((resolve, reject) =>
            setTimeout(() => reject(null), timeout))
    ])
}
